import type { ComponentType } from 'react';
import type { CpDraftInputProps } from './components/CpDraftInput';
import type { CpFooterProps } from './components/CpFooter';
import type { CpReplySuggestionsProps } from './components/CpReplySuggestions';
import { getOwaLazyErrorConfig } from 'mini-error-handler/lib/utils/getOwaLazyErrorConfig';
import { LazyModule } from 'owa-bundling-light';
import type { SummaryServicePayload } from 'mini-copilot-types/lib/schema/Summary.types';
import { withNetworkErrorHandler } from 'mini-error-handler';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CopilotMail" */ './lazyIndex')
);

export const LazyCpFooter: ComponentType<CpFooterProps> = withNetworkErrorHandler(
    null,
    getOwaLazyErrorConfig(lazyModule, m => m.CpFooter, null)
);

export const LazyCpDraftInput: ComponentType<CpDraftInputProps> = withNetworkErrorHandler(
    null,
    getOwaLazyErrorConfig(lazyModule, m => m.CpDraftInput, null)
);

export const LazyCpReplySuggestions: ComponentType<CpReplySuggestionsProps> =
    withNetworkErrorHandler(
        null,
        getOwaLazyErrorConfig(lazyModule, m => m.CpReplySuggestions, null)
    );

export const LazyCpSummarize: ComponentType<SummaryServicePayload> = withNetworkErrorHandler(
    null,
    getOwaLazyErrorConfig(lazyModule, m => m.CpSummarize, null)
);

export const LazyCpProdigiFre = withNetworkErrorHandler(
    null,
    getOwaLazyErrorConfig(lazyModule, m => m.CpProdigiFre, null)
);
